export default __webpack_public_path__ + "static/media/tqqq.cc4c9094.svg";